import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsIntegrationsService} from '../../../services/settings-integrations.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'settings-integrations-apps-list',
    templateUrl: './settings-integrations-apps-list.component.html',
    styleUrls: ['./settings-integrations-apps-list.component.scss']
})
export class SettingsIntegrationsAppsListComponent {
    searchString = '';
    searchDelay: any;

    constructor(
        public urlService: UrlService,
        public settingsIntegrationsService: SettingsIntegrationsService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsIntegrationsService.data.allSettingsAmenities.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        if (checked && this.settingsIntegrationsService.selectedItemData) {
            this.settingsIntegrationsService.toggleDetailedView(null, false);
        } else {
            selectedItem.checked = true;
            this.settingsIntegrationsService.selectedItemData = null;
            setTimeout(() => {
                this.settingsIntegrationsService.toggleDetailedView(selectedItem, true);
            });
        }
    }

    uncheckItem(): void {
        this.settingsIntegrationsService.data.allSettingsAmenities.data.forEach((item) => item.checked = false);
    }

    search(): void {
        const searchTerm = this.searchString ? `*${this.searchString}*` : '';
        this.urlService.updateSearchQuery(searchTerm);
        this.urlService.setQueryParams(null, 1);
    }

    searchOnInput(): void {
        clearTimeout(this.searchDelay);
        this.searchDelay = setTimeout(() => this.search(), 500);
    }

    clearSearch(): void {
        this.urlService.setQueryParams(null, 1);
    }

    changeFilter(): void {

    }

    goToCorporationsList() {
        this.settingsIntegrationsService.isAppsListShow = false;
        this.settingsIntegrationsService.showListView = true;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations-apps-list/settings-integrations-apps-list.component.ts